/* eslint-disable indent */
import { QueryClient } from '@tanstack/react-query';

import { getErrorMessage } from 'utils/axios/getErrorMessage';
import { showSnackbar } from 'utils/snackbar';

export const QUERY_CLIENT_ERROR_KEY = 'query-client-error';

/**
 * Handle query error and show a snackbar with the error message
 * @param {Error} error - The error to handle
 * @returns {void}
 */
export function handleQueryError(error) {
  const message = getErrorMessage(error, 'Error connecting to server');

  // Need to log the error to the console for debugging
  console.error(error);

  showSnackbar(message, {
    variant: 'error',
    key: QUERY_CLIENT_ERROR_KEY,
    preventDuplicate: true,
  });
}

/**
 * Query client configuration
 * @returns {QueryClient}
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      onError: handleQueryError,
      staleTime: 600000, // 10 minutes
      cacheTime: 900000, // 15 minutes
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  },
});
